import { createReducer } from '@reduxjs/toolkit';

import {
  setClientsComplianceReview,
  setComplianceAssignees,
  setComplianceIsLoading,
  setComplianceReviewSelectedClient,
  setComplianceSelectedChecklist,
  setComplianceSelectedChecklistNotes,
  resetAllComplianceInfo,
  resetComplianceContactInfo,
  updateClientComplianceReviewAssignee,
} from 'data/actions/compliance';
import {
  ComplianceQuestion,
  ComplianceNotesMap,
  ClientComplianceReview,
  COMPLIANCE_CHECKLIST_STATUS_ADVISOR_ACTION_REQUIRED,
  COMPLIANCE_CHECKLIST_STATUS_ACTION_REQUIRED,
} from 'data/models/Compliance';

export interface State {
  selectedChecklist: ComplianceQuestion[] | undefined;
  SelectedChecklistNotes: ComplianceNotesMap | undefined;
  clientsComplianceReview: ClientComplianceReview[];
  selectedClientComplianceReview: ClientComplianceReview | undefined;
  isLoading: boolean;
  complianceAssignees: string[];
}

export const initialState: State = {
  selectedChecklist: undefined,
  SelectedChecklistNotes: undefined,
  clientsComplianceReview: [],
  selectedClientComplianceReview: undefined,
  isLoading: false,
  complianceAssignees: [],
};

export default createReducer(initialState, builder => {
  builder.addCase(setComplianceSelectedChecklist, (state, action) => ({
    ...state,
    selectedChecklist: action.payload,
  }));

  builder.addCase(setComplianceSelectedChecklistNotes, (state, action) => ({
    ...state,
    SelectedChecklistNotes: action.payload,
  }));

  builder.addCase(setComplianceAssignees, (state, action) => {
    state.complianceAssignees = action.payload;
  });

  builder.addCase(setClientsComplianceReview, (state, action) => {
    state.clientsComplianceReview = action.payload.map(review => {
      if (review.complianceChecklistStatus === COMPLIANCE_CHECKLIST_STATUS_ADVISOR_ACTION_REQUIRED) {
        return { ...review, complianceChecklistStatus: COMPLIANCE_CHECKLIST_STATUS_ACTION_REQUIRED };
      }
      return review;
    });
  });

  builder.addCase(updateClientComplianceReviewAssignee, (state, action) => {
    const clientToReview = state.clientsComplianceReview.find(client => client.QID === action.payload.qid);
    if (clientToReview) {
      clientToReview.assignee = action.payload.assignee;
    }
  });

  builder.addCase(setComplianceReviewSelectedClient, (state, action) => {
    state.selectedClientComplianceReview = state.clientsComplianceReview.find(client => client.QID === action.payload);
  });

  builder.addCase(setComplianceIsLoading, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(resetAllComplianceInfo, (state, action) => {
    if (!action.payload) return state;
    return { ...initialState };
  });

  builder.addCase(resetComplianceContactInfo, (state, action) => {
    if (!action.payload) return state;
    state.selectedChecklist = undefined;
    state.SelectedChecklistNotes = undefined;
    state.selectedClientComplianceReview = undefined;
  });
});
